import axios from 'axios';

export default {
    listGeneric(
        table,
        tableKey,
        tableField,
        tableField2,
        value,
        value2,
        filter
    ) {
        const payload = {
            table,
            tableKey,
            tableField,
            tableField2,
            tableFieldValue: value,
            tableField2Value: value2,
            tableFilter: filter,
        };

        return axios.post('/generic/listGeneric/', payload);
    },
};
